import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import ListViewItem from "@views/components/ListViewItem";
import DefaultModel from "@views/components/component-models/default-model";

// @Options({
//   components: {
//     DefaultModel,
//     ListViewItem,
//   },
//   props: {
//     title: String,
//     item: ListViewItem,
//     multi: Boolean,
//     typeView: String,
//     // selected: Boolean,
//     // hovered: Boolean,
//     disabled: Boolean,
//     selectAccess: Boolean,
//   },
// })
const title: string = "";
const item: ListViewItem<DefaultModel> = null;
const multi: boolean = false;
const typeView: string = "box";
// selected: Boolean = true;
// hovered: boolean = true;
const disabled: boolean = true;
const selectAccess: boolean = true;
// @Prop({ default: null, type: String }) title!: String;
// // параметры
// @Prop({ default: null, type: Object }) item!: ListViewItem<any>;
// @Prop({ default: false, type: Boolean }) multi!: Boolean;
// @Prop({ default: "box", type: String }) typeView: String;
// @Prop({ default: true, type: Boolean }) selected!: Boolean;
// @Prop({ default: true, type: Boolean }) hovered!: Boolean;
// @Prop({ default: true, type: Boolean }) disabled!: Boolean;
// @Prop({ default: true, type: Boolean }) selectAccess!: Boolean;

const hover: boolean = false;

export default /*#__PURE__*/_defineComponent({
  __name: 'ui-list-view-item',
  props: {
	title: String,
	item: ListViewItem,
	multi: Boolean,
	typeView: String,
	disabled: Boolean,
	selectAccess: Boolean,
},
  setup(__props) {

// import { Component, Vue, Prop, Watch } from "vue-property-decorator";

const prop = __props;
const innerTypeView = typeView;
function created() {
	// console.log(`this.item`, this.item);
}
// mouseover() {
//   if (this.hovered) this.hover = true;
// }
// mouseleave() {
//   if (this.hovered) this.hover = false;
// }
function click(value: ListViewItem<DefaultModel>) {
	if (!this.item.Disabled) {
		//&& this.selectAccess
		this.item.Selected = !this.item.Selected;
		this.$emit("select", this.item);
	}
}
// isHover() {
//   const rez = this.hover && !this.isDisabled();
//   console.log(`rez isHover`, rez);
//   return rez;
// }
// isSelected() {
//   return !this.isHover() && this.item.Selected;
// }
// isDisabled() {
//   return this.item.Disabled;
// }
// isDefault() {
//   const result = !this.isHover() && !this.isSelected();
//   console.log(`result isDefault listItem`, result);
//   return result;
// }
function currentClass() {
	if (this.item.Selected) return "selected";
}

function dragStart(value: DragEvent) {
	if (this.item.Disabled) {
		return;
	}
	value.dataTransfer.effectAllowed = "move";
	value.dataTransfer.setData("application/x-javascript", JSON.stringify(this.item));
	this.$emit("itemDragStart", this.item, value);
}

function dragEnd(value: any) {
	this.$emit("itemdropend", this.item, value);
}

function dragDrop(value: any) {
	value.preventDefault();
	this.$emit("itemdrop", this.item, value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ui-list-view-item", currentClass()]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (click(item))),
    onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
    onDragstart: dragStart,
    onDrop: _withModifiers(dragDrop, ["stop"]),
    onDragend: dragEnd
  }, [
    _renderSlot(_ctx.$slots, "item", { item: item }, () => [
      _createElementVNode("div", {
        class: _normalizeClass([{ disabled: disabled }])
      }, _toDisplayString(item.Value.name), 3)
    ])
  ], 34))
}
}

})